/** @jsx jsx */
import { jsx } from "theme-ui";
import React, { useState, useEffect } from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import Layout from "~/components/layout";
import SEO from "~/components/seo";

import Children from "~/motion/Children";
import SlideUpItem from "~/motion/SlideUpItem";

const Cellar = ({ location }) => {
  const data = useStaticQuery(graphql`
    query cellarQuery {
      site {
        siteMetadata {
          title
        }
      }
      hero: file(relativePath: { eq: "cellarMain.png" }) {
        childImageSharp {
          gatsbyImageData(width: 680)
        }
      }
      cellar1: file(relativePath: { eq: "cellar1.png" }) {
        childImageSharp {
          gatsbyImageData(width: 707)
        }
      }
      cellar2: file(relativePath: { eq: "cellar2.png" }) {
        childImageSharp {
          gatsbyImageData(width: 438)
        }
      }
    }
  `);

  const [shouldAnimate, setShouldAnimate] = useState(false);
  const siteTitle = data.site.siteMetadata?.title || `Title`;

  useEffect(() => {
    setTimeout(() => {
      setShouldAnimate(true);
    }, 0);
  }, []);

  return (
    <Layout location={location} title={siteTitle} pageTitle="Cellar">
      <SEO
        title="Cellar"
        description="Designed in the pursuit of assisting members to enjoy their wines at their absolute peak."
      />
      <Children shouldAnimate={shouldAnimate}>
        <div className="page-padding" />
        <div
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: ["80%", "70%", "50%"],
          }}
        >
          <SlideUpItem>
            <GatsbyImage
              image={data.hero.childImageSharp.gatsbyImageData}
              className="width-100"
              sx={{ maxWidth: ["100%", "100%", 500, 680], position: "relative", zIndex: 1 }}
            />
          </SlideUpItem>
        </div>
        <div className="page-wrap">
          <div
            sx={{
              transform: ["rotate(-90deg)", "rotate(-90deg)", "rotate(0deg)"],
              transformOrigin: "0 0",
              top: [72, 300, 0],
              position: "absolute",
            }}
          >
            <SlideUpItem>
              <h1>Cellar</h1>
            </SlideUpItem>
          </div>

          <div className="bpS-p100">
            <div className="ar ar-60 show-on-mobile"></div>
            <div className="ar ar-60 show-on-mobile"></div>
            <SlideUpItem>
              <p sx={{ maxWidth: 445, mt: [-20, 50] }}>
                Our cellar has been developed in pursuit of enabling guests to drink and enjoy wines
                at their absolute peak. Most wines that have been made with care will benefit from
                further ageing, whether one or ten years, and our team endeavours to enhance the way
                our guests enjoy their wines.
              </p>
            </SlideUpItem>
            <SlideUpItem>
              <p sx={{ maxWidth: 445, mt: 30, fontFamily: "heading" }}>
                Planque guests are encouraged to interact through an ongoing series of events
                designed to inspire conversation and strengthen community. Extending on our ethos of
                wine cellaring, the programme of events will highlight key producers with an
                emphasis on discovering what an aged bottle can become.
              </p>
            </SlideUpItem>
            <ul className="bpS-fs-24 lh-16 mt2">
              <li sx={{ display: "none" }}>
                <SlideUpItem>
                  <Link to="/events/calendar/" className="link link-arrow">
                    Events Calendar
                  </Link>
                </SlideUpItem>
              </li>
              <li>
                <SlideUpItem>
                  <Link to="/membership/" className="link link-arrow">
                    Membership
                  </Link>
                </SlideUpItem>
              </li>
            </ul>
          </div>
        </div>

        <div sx={{ marginBottom: [50, 100] }}>
          <div sx={{ maxWidth: [707], marginTop: [30, 30, 0] }}>
            <SlideUpItem>
              <GatsbyImage image={data.cellar1.childImageSharp.gatsbyImageData} />
            </SlideUpItem>
          </div>

          <div sx={{ marginTop: [30, 30, -250], position: "relative", zIndex: 1 }}>
            <div sx={{ maxWidth: [438], display: "block", marginLeft: "auto" }}>
              <SlideUpItem>
                <GatsbyImage
                  image={data.cellar2.childImageSharp.gatsbyImageData}
                  style={{ width: "100%" }}
                />
              </SlideUpItem>
            </div>
          </div>
        </div>
      </Children>
    </Layout>
  );
};

export default Cellar;
